<section>
  <h3>Kontakt</h3>
  <form-row>
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>Telefon</mat-label>
      <input [disabled]="disable" required matInput type="text" [formControl]="phoneControl" />
      <mat-error *ngIf="phoneControl?.errors?.required">Telefon-Nummer ist erforderlich</mat-error>
      <mat-error *ngIf="phoneControl?.errors?.mustNotMatch">
        Telefon-Nummer darf nicht Ihre eigene sein
      </mat-error>
    </mat-form-field>
  </form-row>
  <form-row>
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>E-Mail</mat-label>
      <input [disabled]="disable" required matInput type="email" [formControl]="mailControl" />
      <mat-error *ngIf="mailControl?.errors?.required">E-Mail-Adresse ist erforderlich</mat-error>
      <mat-error *ngIf="mailControl?.errors?.mustNotMatch">
        E-Mail-Adresse darf nicht Ihre eigene sein
      </mat-error>
      <mat-error *ngIf="mailControl?.errors?.validFormat">
        Die Eingabe entspricht keiner zulässigen E-Mail-Adresse
      </mat-error>
    </mat-form-field>
  </form-row>
</section>
